<div *ngIf="loadingCustomQuestions" style="margin-top: 32px;display: flex;justify-content: center;">
  <p-progressSpinner [style]="{ width: '40px', height: '40px' }" animationDuration=".5s">
  </p-progressSpinner>
</div>


<div *ngIf="!loadingCustomQuestions && customQuestionResponses">
  <div class="question-container">
    <div *ngFor="let serviceType of customQuestionResponses">
      <div>{{serviceType.serviceType}}</div>
      <ul *ngIf="!editQuestions">
        <li *ngFor="let question of serviceType.customQuestionsResponses">
          <div class="row">
            <div class="col-md-4 label bold">{{question.question}}:</div>
            <div class="col-md-8 value">{{ question.response === 'true' ? ('general.yes' | translate) :
              question.response === 'false' ? ('general.no' | translate) : question.response}}</div>
          </div>
        </li>
      </ul>

      <div *ngIf="editQuestions">
        <div *ngFor="let question of serviceType.customQuestionsResponses;let i = index;" class="row"
          [ngClass]="{'margin-top-8': i > 0}">
          <div class="col-md-4 label" [ngClass]="{'red': question.mandatory && !question.response}">
            {{question.question}}</div>
          <div class="col-md-8">
            <div class="p-inputgroup" *ngIf="question.controlType === 'TEXTINPUT'">
              <span class="p-inputgroup-addon"></span>
              <input type="text" pInputText [(ngModel)]="question.response" [placeholder]="question.hint">
            </div>
            <div class="p-inputgroup" *ngIf="question.controlType === 'TEXTAREA'">
              <textarea rows="2" pInputTextarea [(ngModel)]="question.response"
                [placeholder]="question.hint"></textarea>
            </div>
            <div class="p-inputgroup" *ngIf="question.controlType === 'CHECKBOX'">
              <p-checkbox [(ngModel)]="question.response" [binary]="true" inputId="binary"></p-checkbox>
              <small style="margin-left: 8px;font-style: italic;">{{question.hint}}</small>
            </div>
          </div>
        </div>

        <div class="row margin-top-16">
          <div class="col-md-3"><button pButton type="button" [disabled]="busySaving" class="ui-button-raised alternate full-width" label="{{
            'general.cancel' | translate
          }}" (click)="editQuestions = false;getCustomQustions()"></button></div>
          <div class="col-md-6"></div>
          <div class="col-md-3">
            <button pButton type="button" [disabled]="busySaving" class="ui-button-raised full-width" label="{{
                'bikeshop.modal.shared.service_replacement_setup.button.save_changes' | translate
              }}" (click)="updateQuestionResponses()"></button>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div *ngIf="!editQuestions" class="row margin-top-16">
    <div class="col-md-9"></div>
    <div class="col-md-3">
      <button pButton type="button"  class="ui-button-raised full-width" label="{{ 'bikeshop.modal.update_job_card.custom_questions.edit_responses' | translate }}" (click)="editQuestions = true;"></button>
    </div>
  </div>